export default __webpack_public_path__ + "static/media/im-verification-link.394c6c47.svg";